import { gql } from '@/__generated__/gql';

export const GET_AI_RUN_STATUS_QUERY = gql(`
  query AIAssistantGetAIRunStatus($investmentId: String, $AIRunId: String, $recordId: String, $documentType: String!) {
    getAIRunStatus(investmentId: $investmentId, AIRunId: $AIRunId, recordId: $recordId, documentType: $documentType) {
      id
      status
      startedAt
      investment {
        name
      }
      completedAt
      startedBy {
        firstName
        lastName
      }
      filenames
      currentAnswers
      totalAnswers
    }
  }
`);

export const GET_AI_ASSETS_QUERY = gql(`
  query AIAssistantGetDealAssistentAIAssets($data: FetchDealAssistantAIAssetsArgs!) {
    getDealAssistentAIAssets(data: $data) {
      id
      investmentId
      filename
      status
      assetKey
    }
  }
`);

export const GET_AI_CHAT_THREAD_QUERY = gql(`
  query AIAssistantGetChatThread($data: DealAssistantChatThreadArgs!) {
    getChatThread(data: $data) {
      answers {
        prompt
        answer
        citations {
          answer
          pageNumbers
          filename
          fileReferences {
            filename
            pageNumbers
          }
        }
      }
    }
  }
`);

export const GET_AI_ASSET_UPLOAD_URL_QUERY = gql(`
  query AIAssistantGetDealAssistantAIAssetUploadUrl($data: DealAssistantAIAssetUploadUrlDto!) {
    getDealAssistantAIAssetUploadUrl(data: $data) {
      assetKey
      url
    }
  }
`);

export const GET_AI_ASSET_KEY_QUERY = gql(`
  query AIAssistantGetDealAssistentAIAssetKey($data: FetchDealAssistantAIAssetKeyArgs!) {
    getDealAssistentAIAssetKey(data: $data)
  }
`);

export const CREATE_AI_ASSET_MUTATION = gql(`
  mutation AIAssistantCreateDealAssistantAIAsset($data: CreateAIAssetDto!) {
    createDealAssistantAIAsset(data: $data) {
      id
    }
  }
`);

export const PROCESS_AI_ASSET_MUTATION = gql(`
  mutation AIAssistantProcessDealAssistantAIAsset($data: DealAssistantProcessPDFArgs!) {
    processDealAssistantAIAsset(data: $data) {
      id
    }
  }
`);

export const GENERATE_ANSWERS_MUTATION = gql(`
  mutation AIAssistantGenerateAnswers($data: DealAssistantGenerateAnswersAIRunArgs!) {
    generateAnswers(data: $data) {
      id
      status
    }
  }
`);

export const GENERATE_CHAT_REPLY_MUTATION = gql(`
  mutation AIAssistantGenerateChatReply($data: DealAssistantGenerateChatReplyArgs!) {
    generateChatReply(data: $data) {
      answers {
        answer
        citations {
          answer
          prompt
          filename
          embeddingId
          pageNumbers
          fileReferences {
            filename
            pageNumbers
          }
        }
      }
    }
  }
`);
